module.exports = __webpack_public_path__ + "img/portada.8fa45862.png";